import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { redirectTo } from '@utils/Navigation/redirectTo.utils';
import { PagePaths } from '@values/Navigation/PagePaths.value';
import { BookingObjectService } from '@services/booking-object.service';
import { BookingObjectFieldsSelectionService } from '@services/booking-object-fields-selection.service';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cck-booking-breadcrumb',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './booking-breadcrumb.component.html',
  styleUrls: ['./booking-breadcrumb.component.scss'],
})
export class BookingBreadcrumbComponent {
  private readonly _bookingObjectService = inject(BookingObjectService);
  private readonly _bookingObjectFieldsSelectionService = inject(BookingObjectFieldsSelectionService);
  private readonly _breadcrumbService = inject(BreadcrumbService);

  goToStepThree() {
    if (!this.isVisited(3)) return;
    const selectedCruiseIndex = this._bookingObjectFieldsSelectionService.getSelectedCruiseIndex();
    redirectTo(`${PagePaths.step3}?cruisecode1=${this._bookingObjectService?.currentBookingObject?.Cruises?.[selectedCruiseIndex]?.Code}`);
  }

  goToStepFour() {
    if (!this.isVisited(4)) return;

    redirectTo(PagePaths.step3);
  }

  goToStepFive() {
    if (!this.isVisited(5)) return;

    redirectTo(PagePaths.step5);
  }

  isVisited(stepNumber) {
    return this._breadcrumbService.getCurrentStepAsNumber() > stepNumber;
  }

  isCurrent(stepNumber) {
    return this._breadcrumbService.getCurrentStepAsNumber() === stepNumber;
  }
}
